import React, { createContext, useReducer, useContext } from 'react';
import loginReducer from '../reducers/LoginReducer'; // adjust path
import { loginUser } from '../services/LoginService'; // adjust path

const AuthContext = createContext();

const initialState = {
  isLoggedIn: false,
  user: null,
  error: null,
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(loginReducer, initialState);

  const login = async (email,password) => {
    try {
      const userData = await loginUser(email,password);
      console.log("userData:");
      console.log(userData);
      if (userData.message === 'invalid credentials') {
        dispatch({ type: 'LOGIN_FAILURE', payload: 'Email o contraseña incorrectos.' });
        return false;
      }      
      dispatch({ type: 'LOGIN_SUCCESS', payload: userData });
      return true;
    } catch (error) {
      dispatch({ type: 'LOGIN_FAILURE', payload: 'Login failed. Please try again.' });
      return false;
    }
  };

  const logout = () => {
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <AuthContext.Provider value={{
      ...state,
      login,
      logout,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
